import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { logout, hasPermission, isAuthenticated } from "../common/auth";

class MainMenu extends Component {
  state = {
    canLogout: false,
    canEdit: false,
  };

  componentDidMount() {
    const canLogout = isAuthenticated();
    const canEdit = hasPermission("TournamentAuthor");

    this.setState({ canLogout, canEdit });
  }

  render() {
    const { canLogout, canEdit } = this.state;

    return (
      <>
        <Navbar collapseOnSelect expand="sm">
          <Container>
            <Navbar.Brand href={window.location.origin}>
              <img src={`${process.env.PUBLIC_URL}/ats-logo.png`} height="40" alt="" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarCollapse" />
            <Navbar.Collapse id="navbarCollapse">
              <Nav>
                <Nav.Link href={`${process.env.PUBLIC_URL}/`}>Tournaments</Nav.Link>
                {canEdit && <Nav.Link href={`${process.env.PUBLIC_URL}/?planned=all`}>Planned Tournaments</Nav.Link>}
                {!canLogout && <Nav.Link href={`${process.env.PUBLIC_URL}/?signin`}>Sign In</Nav.Link>}
                {canLogout && (
                  <Nav.Link href="#" onClick={() => logout()}>
                    Sign Out
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default MainMenu;
